import { connect } from "react-redux";

import { setPanelState } from "../../../Engine/ActionCreators/HiddenPanelActionCreators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";

import { HiddenPanel } from "./HiddenPanel";

const mapStateToProps = (state: FullFormState) => ({
    panelState: state.formVisualState.panelState,
    isWidePanel: state.formVisualState.isWidePanel,
    panelDisabled: !(state.settings.showNavigationSidebar ?? true),
});

const mapDispatchToProps = {
    onPanelStateChange: setPanelState,
};

export const HiddenPanelContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTestPageObjectRegistration(HiddenPanel, () => ["HiddenPanel"]));
